import _ from 'lodash'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { fetchGetFeatureFlags } from '../queries/feature_flags'
import identitySelectors from '../selectors/identity'

export function useFeatureFlag(featureName: string) {
  const dispatch = useDispatch();
  const { site } = useParams<{site: string}>();
  const userId = useSelector(identitySelectors.getUserId) as string;
  const featureFlagQuery = useQuery(['featureFlags', featureName, { site, userId }], fetchGetFeatureFlags(dispatch));
  const isEnabled = useMemo(() => _.get(featureFlagQuery, 'data.payload.enabled'), [featureFlagQuery.data]);
  return { isEnabled, ...featureFlagQuery };
}
